import { Prisma } from '@repo/database/src/types';

export interface CreateBlindLevelDto {
  levelNumber: number;
  ante: number;
  smallBlind: number;
  bigBlind: number;
  bringIn?: number;
  smallBet?: number;
  bigBet?: number;
}

export const blindStructureWithIncludes = {
  include: {
    levels: {
      select: {
        levelNumber: true,
        ante: true,
        smallBlind: true,
        bigBlind: true,
        bringIn: true,
        smallBet: true,
        bigBet: true,
      },
    },
  },
} satisfies Prisma.TournamentBlindStructureDefaultArgs;

export type BlindStructureWithLevels = Prisma.TournamentBlindStructureGetPayload<typeof blindStructureWithIncludes>;

export type CreateBlindStructureDto = Prisma.TournamentBlindStructureCreateInput & {
  name: string;
  levels: CreateBlindLevelDto[];
};
export type UpdateBlindStructureDto = Prisma.TournamentBlindStructureUpdateInput & {
  levels?: CreateBlindLevelDto[];
};
